<template>
        <v-menu
          v-model="menu"
          :close-on-content-click="true"
          :nudge-width="200"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn large icon dark v-on="on" style="float: right">
              <v-icon size="30" color="secondary">mdi-palette</v-icon>
            </v-btn>
          </template>
          <v-card>
            <!--v-list-item>
              <v-list-item-content
                ><v-list-item-title class="font-weight-bold">
                  Dark Mode</v-list-item-title
                >
              </v-list-item-content>
              <v-list-item-action
                ><v-switch v-model="$vuetify.theme.dark" />
              </v-list-item-action>
            </!--v-list-item>
            <v-divider /-->
            <v-card-text>
              <v-card class="my-2"
                :disabled="$vuetify.theme.themes.name === theme.name"
                @click="setTheme(theme)"
                hover
                outlined
                v-for="(theme, index) in themes"
                :key="index"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ theme.name }}</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-avatar
                      color="success"
                      size="30"
                      v-if="$vuetify.theme.themes.name === theme.name"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-avatar>
                  </v-list-item-action>
                </v-list-item>
                <!--div class="my-2">
                  <v-chip
                    class="mx-1"
                    label
                    :color="typeof theme.dark[key] == 'string' ? theme.dark[key] : theme.dark[key].base"
                    v-for="(key, index) in Object.keys(theme.dark)"
                    :key="index"
                  >
                    {{ key }}</v-chip
                  >
                </!--div-->
                <div class="my-2">
                  <v-chip
                    class="mx-1"
                    label
                    :color="typeof theme.light[key] == 'string' ? theme.light[key] : theme.light[key].base"
                    v-for="(key, index) in Object.keys(theme.light)"
                    :key="index"
                  >
                    {{ key }}</v-chip
                  >
                </div>
              </v-card>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn text @click="menu = false" color="grey">Close</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card> 
        </v-menu>
</template>

<script>

export default {
  data: () => ({
    menu: false,
    themes: [
      {
        name: "StefCastro 1",
        light: {
          primary: "#495464",
          lighten: "#f4f4f2",
          accent: "#bbbfca",
          secondary: "#e8e8e8",
          success: "#33cc66",
          info: "#e8e8e8",
          warning: "#ff9800",//"#ffff00",
          error: "#cc3333",
          accent40: "#bbbfca"
        }
      },
      {
        name: "StefCastro 2",
        light: {
          primary: "#456268",
          lighten: "#fcf8ec", 
          accent: "#d0e8f2",
          secondary: "#79a3b1",
          success: "#8dc63f",
          info: "#d0e8f2",
          warning: "#ff9800",//"#fff200",
          error: "#ff5252",
          accent40: "#d0e8f2"
        }
      },
    ]
  }),
  methods: {
    setTheme(theme) {
      this.menu = false;
      const name = theme.name;
      //const dark = theme.dark;
      const light = theme.light;
      /*Object.keys(dark).forEach(i => {
        this.$vuetify.theme.themes.dark[i] = dark[i];
      });*/
      Object.keys(light).forEach(i => {
        this.$vuetify.theme.themes.light[i] = light[i];
      });
      this.$vuetify.theme.themes.name = name;
    }
  }
};
</script>

